import { environmentBasePartenaires } from './environment-base-partenaires';

export const environment = environmentBasePartenaires.choseAfaire(
    'https://inedit-ro.geo.msp.gouv.qc.ca',
    'partenaires',
    'https://geoegl.msp.gouv.qc.ca',
    'https://courriel.geo.msp.gouv.qc.ca/nous-joindre-vigilance'
);

environment.toPublic = 'https://vigilance.geo.msp.gouv.qc.ca/';
